/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbTypeFinancementGridDto } from './FcbTypeFinancementGridDto';
import {
    FcbTypeFinancementGridDtoFromJSON,
    FcbTypeFinancementGridDtoFromJSONTyped,
    FcbTypeFinancementGridDtoToJSON,
} from './FcbTypeFinancementGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbTypeFinancementGridDtoPaginatedResults
 */
export interface FcbTypeFinancementGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbTypeFinancementGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbTypeFinancementGridDto>}
     * @memberof FcbTypeFinancementGridDtoPaginatedResults
     */
    results?: Array<FcbTypeFinancementGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbTypeFinancementGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbTypeFinancementGridDtoPaginatedResults interface.
 */
export function instanceOfFcbTypeFinancementGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbTypeFinancementGridDtoPaginatedResultsFromJSON(json: any): FcbTypeFinancementGridDtoPaginatedResults {
    return FcbTypeFinancementGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbTypeFinancementGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbTypeFinancementGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbTypeFinancementGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbTypeFinancementGridDtoPaginatedResultsToJSON(value?: FcbTypeFinancementGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbTypeFinancementGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

